import { render, staticRenderFns } from "./RegCheckbox.vue?vue&type=template&id=1e8ebf25&"
import script from "./RegCheckbox.vue?vue&type=script&lang=js&"
export * from "./RegCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./RegCheckbox.vue?vue&type=style&index=0&id=1e8ebf25&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports